/**
 * @Desc Sentry
 * @Author miles
 * @Date 2020-06-11 16:02:34
 * */

import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import Vue from 'vue'

const ENV = process.env.NODE_ENV

if (ENV === 'production') {
  Sentry.init({
    dsn: 'http://28a22dbbb0064789ad241c45a45f9078@sentry.dev.mofaxiao.com/25',
    release: process.env.VERSION,
    integrations: [
      new VueIntegration({ Vue, attachProps: true })
    ],
    environment: ENV
  })
}
export default Sentry
